import React, { useCallback, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useForm } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers";
import {
  fetchTimeSlotFromCentral,
  getAppointmentCount,
  VendorAppointmentCheckWithNewData,
  reserveTimeSlot,
} from "../../services/VendorAppointmentBook";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import useGlobalState from "../../Context";
import { appointmentConstant } from "../../utils/appointmentConstant";

import {
  Button,
  Grid,
  Box,
  Divider,
  FormLabel,
  FormHelperText,
} from "@mui/material";
import {
  convertDateDashYMD,
  dateHash,
  isCountOfSkusGT,
  isDateGreaterThan,
  isSameDate,
  padPO,
  convertDateDashDMY,
  getPOLatestDeliveryDate,
  getPOEarliestDeliveryDate,
} from "../../utils/jsUtils";
import { isDate } from "date-fns";

const Step3 = ({
  onClickNext,
  oldFormData,
  handleBack,
  formData,
  setFormData,
  appointmentTimeSlots,
  uniqueAppointmentTimeSlots,
  setUniqueAppointmentTimeSlots,
  firstTimeCheck,
  setFirstTimeCheck,
  setAppointmentTimeSlots,
  materialTypeList,
  appointmentStore,
  setAppointmentStore,
  config,
  deliveryBookingWindow,
  siteConfig,
  listOfPO,
}) => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm();
  const appointmentDateValue = getValues("appointmentDate") ?? null;
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [appointmentTime, setAppointmentTime] = useState(null);
  const [showSlots, setShowSlots] = useState(false);
  const [timeSlotInfo, setTimeSlotInfo] = useState(null);

  // const currentDate = new Date();
  // const daysAheadDate = new Date();
  // daysAheadDate.setDate(
  //   daysAheadDate?.getDate() +
  //     (config?.vendorAppointmentBookingWindow >= deliveryBookingWindow
  //       ? deliveryBookingWindow
  //       : config?.vendorAppointmentBookingWindow)
  // );
  // currentDate.setDate(currentDate.getDate() + 1);

  let currentDate = new Date();

  // Default minDate (currentDate + 1)
  let minDate = new Date(currentDate);
  minDate.setDate(currentDate.getDate() + 1);

  let maxDate = new Date(currentDate); // Initialize maxDate with today's date

  if (config?.enableVendorDeliveryDateCheck) {
    let baseDate = new Date();
    let maxBookingWindow = new Date();

    let bookingWindow = config?.vendorAppointmentBookingWindow || 60;
    baseDate.setDate(baseDate.getDate() + deliveryBookingWindow);
    maxBookingWindow.setDate(maxBookingWindow.getDate() + bookingWindow);

    // 🆕 Modify minDate and maxDate based on listOfPO
    if (Array.isArray(listOfPO) && listOfPO.length > 0) {
      let maxEarliestPODate = new Date(
        Math.max(
          ...listOfPO.map((po) => getPOEarliestDeliveryDate(po)?.getTime() || 0)
        )
      );
      let minLatestPODate = new Date(
        Math.min(
          ...listOfPO.map(
            (po) => getPOLatestDeliveryDate(po)?.getTime() || Infinity
          )
        )
      );

      let vendorMinDeliveryDays = config?.vendorMinDeliveryDate || 0;
      let vendorMaxDeliveryDays = config?.vendorMaxDeliveryDate || 0;

      // Calculate minDate
      minDate = new Date(maxEarliestPODate);
      minDate.setDate(minDate.getDate() - vendorMinDeliveryDays);

      // Calculate maxDate
      maxDate = new Date(minLatestPODate);
      maxDate.setDate(maxDate.getDate() + vendorMaxDeliveryDays);
    }

    // Ensure minDate is not in the past
    if (minDate <= currentDate) {
      minDate = new Date(currentDate);
      minDate.setDate(currentDate.getDate() + 1);
    }

    // Ensure maxDate does not exceed maxBookingWindow
    if (maxDate > maxBookingWindow) {
      maxDate = maxBookingWindow;
    }
  } else if (siteConfig?.configs?.enableVendorDeliveryDateCheck) {
    let baseDate = new Date();
    let maxBookingWindow = new Date();

    let bookingWindow = config?.vendorAppointmentBookingWindow || 60;
    baseDate.setDate(baseDate.getDate() + deliveryBookingWindow);
    maxBookingWindow.setDate(maxBookingWindow.getDate() + bookingWindow);

    if (Array.isArray(listOfPO) && listOfPO.length > 0) {
      let maxEarliestPODate = new Date(
        Math.max(
          ...listOfPO.map((po) => getPOEarliestDeliveryDate(po)?.getTime() || 0)
        )
      );
      let minLatestPODate = new Date(
        Math.min(
          ...listOfPO.map(
            (po) => getPOLatestDeliveryDate(po)?.getTime() || Infinity
          )
        )
      );

      let vendorMinDeliveryDays =
        siteConfig?.configs?.vendorMinDeliveryDate || 0;
      let vendorMaxDeliveryDays =
        siteConfig?.configs?.vendorMaxDeliveryDate || 0;

      // Calculate minDate
      minDate = new Date(maxEarliestPODate);
      minDate.setDate(minDate.getDate() - vendorMinDeliveryDays);

      // Calculate maxDate
      maxDate = new Date(minLatestPODate);
      maxDate.setDate(maxDate.getDate() + vendorMaxDeliveryDays);
    }
    // Ensure minDate is not in the past
    if (minDate <= currentDate) {
      minDate = new Date(currentDate);
      minDate.setDate(currentDate.getDate() + 1);
    }

    // Ensure maxDate does not exceed maxBookingWindow
    if (maxDate > maxBookingWindow) {
      maxDate = maxBookingWindow;
    }
  } else {
    let daysToAdd =
      (config?.vendorAppointmentBookingWindow ?? 60) >= deliveryBookingWindow
        ? deliveryBookingWindow
        : config?.vendorAppointmentBookingWindow ?? 60;

    maxDate = new Date(currentDate);
    maxDate.setTime(maxDate.getTime() + daysToAdd * 24 * 60 * 60 * 1000);
  }

  const [{ userDetails }] = useGlobalState();
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);

  useEffect(() => {
    if (config?.vendorAppointmentBookingWindow >= deliveryBookingWindow) {
      const todayDate = new Date();
      setError("appointmentDate", {
        message: `Appointment Permissible between ${convertDateDashDMY(
          minDate
        )}  to ${convertDateDashDMY(maxDate)} `,
      });
    }
    setAppointmentDate(appointmentDateValue || null);
  }, [
    setAppointmentDate,
    appointmentDateValue,
    config?.vendorAppointmentBookingWindow,
    deliveryBookingWindow,
    showNotification,
    setError,
  ]);

  const parseToTimeSlotPoParams = useCallback(
    (poParams) => {
      return poParams.map((object) => {
        return {
          poNumber: object?.poNumber,
          noOfCases: object?.noOfCases,
          countOfSkus: object?.countOfSkus,
          materialTypeParams: [
            {
              materialTypeId: object?.materialTypeId,
              materialType:
                materialTypeList?.find(
                  (obj) =>
                    obj.materialTypeId === parseInt(object?.materialTypeId)
                )?.materialType ?? "",
            },
          ],
        };
      });
    },
    [materialTypeList]
  );

  const selectTimeSlot = (slot, uniqueAppointmentTimeSlots) => {
    setEnableNext(false);
    slot.isReserved = 1;
    setTimeSlotInfo(slot);
    setSelectedTimeSlot(slot);
    uniqueAppointmentTimeSlots.forEach((element, index) => {
      if (element.timeSlotId !== slot.timeSlotId) {
        element.isReserved = 0;
      } else {
        console.debug(element, "match element");
      }
    });
  };

  const checkEqualTimeSlot = (appointmentTimeSlots, timeSlotInfo) => {
    var timeSlotList = appointmentTimeSlots.filter(function (element) {
      return timeSlotInfo.timeSlot === element.timeSlot;
    });
    return timeSlotList;
  };

  const userInfo = {
    userId: userDetails?.userParam?.userId,
  };

  function getTimeslotFetchRequestBody(
    formData,
    date,
    userInfo,
    parseToTimeSlotPoParams
  ) {
    return {
      fcCode: formData?.fcCode,
      appointmentDate: convertDateDashYMD(date),
      vendorCode: padPO(formData?.vendorCode),
      vendorName: formData?.vendorName,
      vendorUserId: formData?.vendorUserId,
      parentSiteCode: formData?.parentSiteCode,
      poParams: parseToTimeSlotPoParams(formData?.poDetails),
    };
  }

  function getRequestBodyForFetchTimeSlots(
    formData,
    date,
    userInfo,
    groupedData
  ) {
    return {
      fcCode: formData?.fcCode,
      appointmentDate: convertDateDashYMD(date),
      vendorCode: padPO(formData?.vendorCode),
      vendorName: formData?.vendorName,
      vendorUserId: formData?.vendorUserId,
      parentSiteCode: formData?.parentSiteCode,
      poParams: groupedData,
    };
  }

  function iterateArticleData(groupedData, item, prepareArticleData, found) {
    for (const entry of groupedData) {
      // If the PO number already exists, add the article to its existing articles array
      if (entry.poNumber === item.poNumber) {
        prepareArticleData(entry, item);
        found = true;
        break;
      }
    }
    return found;
  }

  function prepareArticleData(entry, item) {
    entry.articleParams.push({
      articleCode: item.articleCode,
      articleName: item.articleName,
      articleBoxQuantity: Number(item.articleBoxQuantity),
      articleQuantity: item.articleQuantity,
      eanNumber: item.eanNumber,
      familyCode: item.familyCode,
      familyName: item.familyName,
      deliveryDate: item.deliveryDate,
    });
  }

  function addNewArticleEntry(found, groupedData, item) {
    if (!found) {
      groupedData.push({
        poNumber: item.poNumber.toString(),
        articleParams: [
          {
            articleCode: item.articleCode,
            articleName: item.articleName,
            articleBoxQuantity: Number(item.articleBoxQuantity),
            articleQuantity: item.articleQuantity,
            eanNumber: item.eanNumber,
            familyCode: item.familyCode,
            familyName: item.familyName,
            deliveryDate: item.deliveryDate,
          },
        ],
      });
    }
  }

  const handleTimeSlot = useCallback(
    async (date) => {
      try {
        setLoading(true);
        let timeSlotResponse = null;
        if (
          dateHash(date) in appointmentStore &&
          appointmentStore[dateHash(date)]?.expiration > new Date()
        ) {
          timeSlotResponse = appointmentStore[dateHash(date)];
        } else {
          const sameDate = isSameDate(date, oldFormData?.appointmentDate);
          const getCountRequestBody = {
            fcCode: formData?.fcCode,
            appointmentDate: convertDateDashYMD(date),
            vendorCode: padPO(formData?.vendorCode),
          };
          let appointmentCountResponse = {};

          if (!sameDate) {
            appointmentCountResponse = await getAppointmentCount(
              baseUrl,
              getCountRequestBody
            );
          }

          // if (appointmentCountResponse?.allowNewAppointment) {
          if (formData?.strategy === appointmentConstant.TOTAL_BOX_COUNT) {
            const requestBody = getTimeslotFetchRequestBody(
              formData,
              date,
              userInfo,
              parseToTimeSlotPoParams
            );
            timeSlotResponse = {
              ...(await fetchTimeSlotFromCentral(baseUrl, requestBody)),
              // newFetch: true,
            };
          } else {
            const groupedData = [];

            formData?.selectedArticles.forEach((item) => {
              // Flag to check if the PO number already exists
              let found = false;

              // Iterate over each entry in the grouped data array
              found = iterateArticleData(
                groupedData,
                item,
                prepareArticleData,
                found
              );

              // If the PO number doesn't exist, add a new entry
              addNewArticleEntry(found, groupedData, item);
            });

            const requestBody = getRequestBodyForFetchTimeSlots(
              formData,
              date,
              userInfo,
              groupedData
            );
            timeSlotResponse = {
              ...(await fetchTimeSlotFromCentral(baseUrl, requestBody)),
              // newFetch: true,
            };
          }
        }
        if (timeSlotResponse?.messageCode === 6) {
          clearErrors("startTime");
          let currentTime = new Date();
          currentTime.setTime(currentTime?.getTime() + 5 * 60 * 1000);
          setAppointmentStore({
            ...appointmentStore,
            [dateHash(date)]: { ...timeSlotResponse, expiration: currentTime },
          });
          if (!!timeSlotResponse?.timeSlotParam) {
            const timeSlotParam = timeSlotResponse?.timeSlotParam;
            setValue("appointmentDate", date);
            setAppointmentDate(date);
            setValue("startTime", timeSlotParam?.timeSlot);
            setValue("endTime", timeSlotParam?.slotEndTime);
            setAppointmentTime(timeSlotParam?.timeSlot);
            setTimeSlotInfo(timeSlotParam);
            setShowSlots(false);
          } else {
            setShowSlots(true);
            setAppointmentTimeSlots(timeSlotResponse?.timeSlotParams[0]);
            const key = "timeSlot";
            const unique = [
              ...new Map(
                timeSlotResponse?.timeSlotParams[0].map((item) => [
                  item[key],
                  item,
                ])
              ).values(),
            ];
            setUniqueAppointmentTimeSlots(unique);
          }
        } else {
          setValue("startTime", null);
          setValue("endTime", null);
          setAppointmentTime(null);
          showNotification(
            "Error",
            timeSlotResponse?.message ??
              "Failed To Fetch Time Slot For The Selected Date"
          );
        }
      } catch (err) {
        showNotification(
          "Error",
          err?.message ?? "Failed To Fetch Time Slot For The Selected Date"
        );
      } finally {
        setLoading(false);
      }
    },
    [
      setLoading,
      appointmentStore,
      oldFormData?.appointmentDate,
      formData?.fcCode,
      formData?.vendorCode,
      formData?.parentSiteCode,
      formData?.vendorName,
      formData?.vendorUserId,
      formData?.poDetails,
      baseUrl,
      parseToTimeSlotPoParams,
      clearErrors,
      setAppointmentStore,
      setValue,
      setAppointmentTimeSlots,
      setUniqueAppointmentTimeSlots,
      showNotification,
    ]
  );

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const sameDate = isSameDate(
        data.appointmentDate,
        oldFormData?.appointmentDate
      );
      // if (!sameDate) {
      let timeSlotResponse = null;
      var timeSlotList = checkEqualTimeSlot(appointmentTimeSlots, timeSlotInfo);
      const requestBody = {
        timeSlotList: timeSlotList,
        fcCode: formData?.fcCode,
        appointmentDate: convertDateDashYMD(selectedTimeSlot?.fcDate),
        vendorCode: padPO(formData?.vendorCode),
        vendorName: formData?.vendorName,
        vendorUserId: userInfo?.userId,
        poParams: parseToTimeSlotPoParams(formData?.poDetails),
      };
      console.debug(
        "Time Slot List sent for acquiring locking",
        requestBody.timeSlotList
      );
      timeSlotResponse = await reserveTimeSlot(baseUrl, requestBody);
      if (timeSlotResponse?.messageCode === 6) {
        if (showSlots) {
          const appointDateArr = selectedTimeSlot?.fcDate.split("-");
          setFormData({
            ...formData,
            appointmentDate: new Date(
              appointDateArr?.[0],
              appointDateArr?.[1] - 1,
              appointDateArr?.[2]
            ),
            startTime: selectedTimeSlot?.timeSlot,
            endTime: selectedTimeSlot?.slotEndTime,
            showSlot: true,
            timeSlotInfo: timeSlotInfo,
            timeSlotRefId: timeSlotResponse?.timeSlotParam?.timeSlotId,
            dockId: timeSlotResponse?.timeSlotParam?.dockId,
          });
        } else {
          setFormData({
            ...formData,
            ...data,
            showSlot: false,
            timeSlotInfo: timeSlotInfo,
            timeSlotRefId: timeSlotResponse?.timeSlotParam?.timeSlotId,
            dockId: timeSlotInfo?.dockId,
          });
        }
        onClickNext();
      } else {
        showNotification(
          "Error",
          timeSlotResponse?.message ??
            "Failed To Reserve Time Slot For The Selected Date"
        );
      }
      // } else {
      //   setFormData({
      //     ...formData,
      //     ...data,
      //     showSlot: false,
      //     timeSlotInfo: timeSlotInfo,
      //     timeSlotRefId: oldFormData.timeSlotRefId,
      //     dockId: timeSlotInfo?.dockId,
      //   });
      //   onClickNext();
      // }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed To Reserve Time Slot For The Selected Date"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    register("appointmentDate", { required: true });
  }, [register]);

  const checkAppointmentstatus = async () => {
    try {
      if (firstTimeCheck) {
        setFirstTimeCheck(false);
        let vendorDataValidateResponse = { slotCheck: true };
        if (isCountOfSkusGT(formData, oldFormData)) {
          setLoading(true);
          const checkRequestObj = {
            timeSlotRefId: oldFormData?.timeSlotRefId,
            fcCode: formData?.fcCode,
            appointmentDate: convertDateDashYMD(oldFormData?.appointmentDate),
            vendorCode: padPO(formData?.vendorCode),
            vendorName: formData?.vendorName,
            vendorUserId: formData?.vendorUserId,
            poParams: parseToTimeSlotPoParams(formData?.poDetails),
          };
          vendorDataValidateResponse = await VendorAppointmentCheckWithNewData(
            baseUrl,
            checkRequestObj
          );
        }

        if (
          !vendorDataValidateResponse?.slotCheck &&
          formData?.bookingType !== "RESERVATION"
        ) {
          setLoading(false);
          setValue("appointmentDate", null);
          setAppointmentDate(null);
          setValue("startTime", null);
          setValue("endTime", formData?.endTime);
          setAppointmentTime(null);
          setFormData({
            ...formData,
            appointmentDate: null,
            startTime: null,
          });
          setTimeSlotInfo(formData?.timeSlotInfo);
        } else {
          await setValue("appointmentDate", oldFormData?.appointmentDate);
          setAppointmentDate(oldFormData?.appointmentDate);
          setValue("startTime", oldFormData?.startTime);
          setAppointmentTime(oldFormData?.startTime);
          setTimeSlotInfo(oldFormData?.timeSlotInfo);
          setFormData({
            ...formData,
            appointmentDate: oldFormData?.appointmentDate,
            startTime: oldFormData?.startTime,
          });
        }
      } else {
        if (formData?.appointmentDate && formData?.startTime) {
          if (formData?.showSlot) {
            setShowSlots(true);
            const selectedTempSlot = appointmentTimeSlots?.find(
              (slot) => slot?.timeSlotId === formData?.selectedSlotId
            );
            setValue("appointmentDate", formData?.appointmentDate);
            setSelectedTimeSlot(selectedTempSlot);
          } else {
            setValue("appointmentDate", formData?.appointmentDate);
            setAppointmentDate(formData?.appointmentDate);
            setValue("startTime", formData?.startTime);
            setAppointmentTime(formData?.startTime);
          }
          setTimeSlotInfo(formData?.timeSlotInfo);
        }
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Network error");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    checkAppointmentstatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatTime = (timeString) => {
    if (!timeString) return "-"; // Return a hyphen if timeString is null or undefined

    const [hours, minutes] = timeString.split(":");
    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
  };

  const errorStyles = {
    color: "orange !important", // Change the color to your desired color
    fontSize: "13px", // Optionally adjust font size
    // Add any other styles as needed
  };

  const [enableNext, setEnableNext] = useState(true);
  const changeTimeSlot = () => {
    handleTimeSlot(formData?.appointmentDate);
    setEnableNext(false);
  };

  return (
    <>
      <Grid className="bg-white">
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={12} sx={{ p: 4 }}>
            <Box sx={{ mt: 3 }}>
              <form>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <FormLabel
                      required={true}
                      className="stepperFormLabel"
                      sx={{
                        width: "220px",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      Appointment Date
                    </FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        // minDate={currentDate}
                        // maxDate={daysAheadDate}
                        minDate={minDate}
                        maxDate={maxDate}
                        value={appointmentDateValue}
                        name="appointmentDate"
                        onChange={async (date) => {
                          if (
                            isDate(date) &&
                            isDateGreaterThan(maxDate, date) &&
                            isDateGreaterThan(date, currentDate)
                          ) {
                            setValue("appointmentDate", date, {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                            await handleTimeSlot(date);
                          } else {
                            setValue("startTime", null);
                            setValue("endTime", null);
                            setAppointmentTime(null);
                            showNotification(
                              "Error",
                              "Booking For Selected Date Is Not Available"
                            );
                          }
                        }}
                        inputFormat="dd/MM/yyyy"
                        sx={{ pl: 1, pt: 1 }}
                        renderInput={(params) => (
                          <TextField
                            className="stepperFormInput4"
                            name="appointmentDate"
                            fullWidth
                            required
                            type="date"
                            size="small"
                            autoComplete="off"
                            error={Boolean(errors?.appointmentDate)}
                            helperText={
                              errors?.appointmentDate
                                ? errors?.appointmentDate?.message ??
                                  "This field is required"
                                : ""
                            }
                            {...params}
                            sx={{ width: "35%" }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                    {Boolean(errors?.appointmentDate) && (
                      <>
                        <br></br>
                        <Box display="flex" justifyContent={"center"}>
                          <FormHelperText error style={errorStyles}>
                            {errors?.appointmentDate?.message ? "" : ""}
                          </FormHelperText>
                        </Box>
                      </>
                    )}
                  </Grid>
                  {showSlots ? (
                    <>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        container
                        spacing={2}
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item xs={6} sm={6} textAlign="center">
                          Select Time Slot
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          container
                          spacing={2}
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid
                            container
                            spacing={{ xs: 2, md: 1 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                          >
                            {uniqueAppointmentTimeSlots?.map((slot, i) => {
                              return (
                                <Grid
                                  item
                                  xs={2}
                                  sm={1}
                                  md={1}
                                  sx={{ marginTop: "20px;" }}
                                >
                                  <Button
                                    variant={
                                      slot.isReserved === 1
                                        ? "contained"
                                        : "outlined"
                                    }
                                    color="primary"
                                    onClick={() => {
                                      selectTimeSlot(
                                        slot,
                                        uniqueAppointmentTimeSlots
                                      );
                                    }}
                                  >
                                    {formatTime(slot?.timeSlot)}
                                  </Button>
                                </Grid>
                              );
                            })}
                          </Grid>
                          {Boolean(errors?.startTime) && (
                            <FormHelperText error>
                              {errors?.startTime
                                ? "This field is required"
                                : ""}
                            </FormHelperText>
                          )}
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    !!appointmentDate && (
                      <>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          display="flex"
                          justifyContent="center"
                          alignContent="center"
                          flexDirection={"row"}
                        >
                          <FormLabel
                            required={true}
                            className="stepperFormLabel"
                            sx={{
                              width: "220px",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            Time Slot
                          </FormLabel>
                          <TextField
                            variant="outlined"
                            className="stepperFormInput4"
                            name="startTime"
                            value={appointmentTime}
                            disabled
                            required
                            fullWidth
                            size="small"
                            autoComplete="off"
                            {...register("startTime", {
                              required: true,
                            })}
                            error={Boolean(errors?.startTime)}
                            helperText={
                              errors?.startTime ? "This field is required" : ""
                            }
                          ></TextField>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          display="flex"
                          justifyContent="center"
                          alignContent="center"
                          flexDirection={"row"}
                        >
                          <Button
                            onClick={changeTimeSlot}
                            // sx={{ mr: 1 }}
                            variant="outlined"
                            sx={{
                              width: "220px",
                              marginTop: "10px",
                              marginBottom: "10px",
                              ml: 9,
                            }}
                          >
                            Change Time Slot
                          </Button>
                        </Grid>
                      </>
                    )
                  )}
                </Grid>
              </form>
            </Box>
          </Grid>
          <React.Fragment>
            <Divider />
            <Box sx={{ display: "flex", flexDirection: "row", p: 2 }}>
              <Button variant="outlined" onClick={handleBack} sx={{ mr: 1 }}>
                Back
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button
                type="submit"
                onClick={handleSubmit(onSubmit)}
                sx={{ mr: 1 }}
                variant="outlined"
                disabled={enableNext}
              >
                Next
              </Button>
            </Box>
          </React.Fragment>
        </Grid>
      </Grid>
    </>
  );
};
export default Step3;
